import { ExceptionService } from '@exceptions-service';
import { IErrorResponse, IDialogData } from '@interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { IGroup, Group } from '@group/group.structure';
import { GroupService } from '@group/group.service';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormGroup, } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControlService } from '@base/form-controls.service';
import { EMPTY } from '@base/utils';

@Component({
  selector: 'app-dialog-group',
  templateUrl: './dialog-group.component.html',
  styleUrls: ['./dialog-group.component.sass']
})
export class DialogGroupComponent implements OnInit {
  name = new FormControl(null, [
    Validators.required, Validators.maxLength(25),
    Validators.pattern('^[A-Za-z\-\ 0-9\_\ñ]+'),
  ]);
  groupForm: FormGroup;
  showSpinner = false;
  private _edit = false;
  private _group: IGroup;
  private _members = [];
  private _users = [];
  private _company_id = 0;

  constructor(
    private fb: FormBuilder,
    private groupService: GroupService,
    public dialogRef: MatDialogRef<DialogGroupComponent>,
    private exceptionService: ExceptionService,
    private formControlService: FormControlService,
    @Inject(MAT_DIALOG_DATA) public info: object
  ) {
    this.groupForm = this.fb.group({
      name: this.name,
    });
  }

  ngOnInit() {
    this._group = this.info['group'];
    this.groupForm.setValue({
      name: this._group.name,
    });
    this._edit = this.info['edit'];
    this._company_id = this._group.company;
  }

  onSubmit() {
    this.groupForm.disable();
    let group: IGroup = EMPTY;
    this.showSpinner = true;
    group = (!this._edit) ? new Group(this.groupForm.value) : { ...this._group, ...this.groupForm.value, };
    group.id = this._group.id;
    group.company = this._company_id;
    group.slug = group.name.trim().toLowerCase().replace(/ /g, '-');
    group.members = this._members.concat(this._users);

    // es una nueva empresa
    if (this._company_id === 0) {
      // se creara el grupo en el state (temporal).
      this.sendResponse(group);
    } else if (this._company_id > 0) {
      // esta editando una empresa y creando un grupo a esa empresa
      const obs = (this._edit) ? this.groupService.updateGroup(group) : this.groupService.createGroup(group);
      obs.subscribe(
        (response: IGroup) => {
          this.sendResponse(response);
        },
        (err: HttpErrorResponse) => {
          this.showSpinner = false;
          const error: IErrorResponse = this.exceptionService.errorHandling(err);
          console.log(error.message);
          this.sendResponse(null);
        }
      );
    }
  }

  sendResponse(group: IGroup) {
    this.showSpinner = false;
    this.groupForm.reset();
    this.dialogRef.close(group);
  }

  getErrorMessage(control: FormControl) {
    const strError = this.formControlService.checkErrorInControl(control);
    return strError;
  }
}
